import Vue from 'vue'
import Vuex from 'vuex'
import { alert } from './_alert'
import { authentication } from './_authentication'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        alert,
        authentication
    },
    getters: {
        alert: state => {
            return state.alert
        },
        loggedIn: state => {
            return state.authentication.status.loggedIn
        },
        userName: state => {
            return state.authentication.user.username
        },
        userRole: state => {
            return state.authentication.user.role
        },
        userRated: state => {
            if (!state.authentication.user.rating) {
                return false
            }
            return !!state.authentication.user.rating.ratedAt
        },
        accountName: state => {
            return state.authentication.user.account.name
        },
        accountActive: state => {
            return state.authentication.user.account.active
        }
    }
})
